import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { BIZDEV_NAV } from './nav';

const GrowthOverview: React.FC = () => {
    const { api } = useInternalApi();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Growth Overview - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('bizdev-api/growth-overview/').then(r => {
            if (r.data?.status === 'success') setData(r.data.data);
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const maxVal = data ? Math.max(1, ...data.series.flatMap((s: any) => [s.patients, s.providers, s.leads])) : 1;

    return (
        <InternalShell activeDashboard="business_development" subNav={BIZDEV_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faChartLine} className="me-2 text-primary" />Growth Overview</h2>
            <p className="text-muted mb-4">Real acquisition by month, and what is currently in the pipeline</p>

            {loading || !data ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    <div className="row mb-4">
                        {Object.entries(data.totals).map(([k, v]) => (
                            <div className="col-md-2 col-6 mb-3" key={k}>
                                <div className="card border-0 shadow-sm h-100"><div className="card-body">
                                    <div className="text-muted small mb-1 text-capitalize">{k.replace(/_/g, ' ')}</div>
                                    <h4>{v as any}</h4>
                                </div></div>
                            </div>
                        ))}
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Open leads</div><h4>{data.pipeline.open_leads}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Estimated seats in pipeline</div><h4>{data.pipeline.estimated_seats}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Won all time</div><h4 className="text-success">{data.pipeline.won_all_time}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Lost all time</div><h4 className="text-muted">{data.pipeline.lost_all_time}</h4>
                        </div></div></div>
                    </div>

                    <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{data.note}</div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white"><strong>Acquisition by month</strong></div>
                        <div className="card-body p-0">
                            {data.series.length === 0 ? (
                                <div className="text-center py-5 text-muted">No registrations in the last 12 months.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Month</th><th>Patients</th><th>Practitioners</th><th>Leads created</th><th style={{ width: '35%' }}>Relative volume</th></tr></thead>
                                    <tbody>
                                        {data.series.map((s: any) => (
                                            <tr key={s.month}>
                                                <td>{s.month}</td>
                                                <td>{s.patients}</td>
                                                <td>{s.providers}</td>
                                                <td>{s.leads}</td>
                                                <td>
                                                    <div className="progress" style={{ height: 8 }}>
                                                        <div className="progress-bar bg-info" style={{ width: `${(s.patients / maxVal) * 100}%` }} title={`Patients: ${s.patients}`} />
                                                        <div className="progress-bar bg-success" style={{ width: `${(s.providers / maxVal) * 100}%` }} title={`Practitioners: ${s.providers}`} />
                                                        <div className="progress-bar bg-warning" style={{ width: `${(s.leads / maxVal) * 100}%` }} title={`Leads: ${s.leads}`} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default GrowthOverview;
